export default __webpack_public_path__ + "static/media/d6.03dfbd39.png";